import { derived, writable } from 'svelte/store';

function createNavigationStore() {
  const pendingCount = writable(0);

  return {
    subscribe: pendingCount.subscribe,
    start() {
      pendingCount.update((count) => count + 1);
    },
    finish() {
      pendingCount.update((count) => Math.max(0, count - 1));
    },
    reset() {
      pendingCount.set(0);
    },
  };
}

export const navigation = createNavigationStore();
export const isNavigationPending = derived(navigation, ($count) => $count > 0);
